export default __webpack_public_path__ + "static/media/fruit_bowl.4b37692a.jpg";